import {SliderClients} from './SliderClients';
export default SliderClients;
